import { shallow } from 'zustand/shallow';
import { createWithEqualityFn as createStore } from 'zustand/traditional';

const DebugModeWindowKey = '__kcf_debug_mode';

type KcfWindow = {
    [DebugModeWindowKey]: boolean | undefined;
};

/**
 * infallible way to check for debug mode regardless of context, for use in
 * places that _really_ shouldn't rely on state (e.g. ErrorPage)
 */
export const getIsDebugModeSafely = () => {
    try {
        return !!((window as unknown) as KcfWindow)[DebugModeWindowKey];
    } catch {
        return false;
    }
};

export type DebugState = {
    isDebugMode: boolean;
    toggleIsDebugMode: () => void;
};

const useDebugStore = createStore<DebugState>(
    (set, _get) => ({
        isDebugMode: false,
        toggleIsDebugMode: () =>
            set(({ isDebugMode }) => ({
                isDebugMode: (((window as unknown) as KcfWindow)[
                    DebugModeWindowKey
                ] = !isDebugMode),
            })),
    }),
    shallow
);

export const useDebug = () => useDebugStore((state) => state, shallow);
